import { render, staticRenderFns } from "./CustomerDataTable.vue?vue&type=template&id=70cc336f&"
import script from "./CustomerDataTable.vue?vue&type=script&lang=js&"
export * from "./CustomerDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VIcon,
})
